module.exports = __webpack_public_path__ + "static/media/timetable2.a3e22833.svg";